export const fillInBlankInputLabel = (blankNumber: number, totalBlanks: number, blankAllowed = false) => {
  const blankAllowedText = blankAllowed ? ', or leave empty' : ''
  return `Blank ${blankNumber} of ${totalBlanks}${blankAllowedText}`
}
